import { useEffect, useState, createContext, useContext } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Founder from "@/components/Founder";
import Problems from "@/components/Problems";
import Ecosystem from "@/components/Ecosystem";
import Programs from "@/components/Programs";
import MiniCourses from "@/components/MiniCourses";
import WhatYouGet from "@/components/WhatYouGet";
import TravelCallout from "@/components/TravelCallout";
import Recipes from "@/components/Recipes";
import WhyDifferent from "@/components/WhyDifferent";
import Journey from "@/components/Journey";
import Transformation from "@/components/Transformation";
import Testimonials from "@/components/Testimonials";
import Resources from "@/components/Resources";
import Community from "@/components/Community";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import DiscoveryModal from "@/components/DiscoveryModal";
import MobileCta from "@/components/MobileCta";

const BookingContext = createContext({ openBooking: () => {} });
export const useBooking = () => useContext(BookingContext);

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BookingContext.Provider value={{ openBooking: () => setBookingOpen(true) }}>
      <div className="bg-ivory text-forest font-sans">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Founder />
          <Problems />
          <Ecosystem />
          <Programs />
          <MiniCourses />
          <WhatYouGet />
          <TravelCallout />
          <Recipes />
          <WhyDifferent />
          <Journey />
          <Transformation />
          <Testimonials />
          <Resources />
          <Community />
          <Faq />
          <FinalCta />
        </main>
        <Footer />
        <DiscoveryModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
        <MobileCta hidden={bookingOpen} />
      </div>
    </BookingContext.Provider>
  );
}

export default App;
